import { createSelector } from '@reduxjs/toolkit'

import { AppState } from '@app/store/reducer'

const homepageStateSelector = (state: AppState) => state.homepage

export const locationCountSelector = createSelector(homepageStateSelector, ({ locationData }) => {
  const statesCount = locationData?.states?.length || 0
  const citiesCount = locationData?.states?.reduce((counter, state) => counter + state.cities?.length, 0) || 0

  return {
    statesCount,
    citiesCount
  }
})
